import React, { useState } from 'react';


import "@fontsource/mulish"; // Defaults to weight 400.




import {InputField}  from '@next-components/input-field';
import { Button } from '@next-components/cta';
import { Label } from '@next-components/label';

import { makeStyles } from '@mui/styles';

import AppHeader from './AppHeader'
import Login from './Login';
import InvoiceMainView from './InvoiceMainView';





const useStyles = makeStyles(theme => ({
    maincolumn: {        
        fontFamily:'Mulish', 
        fontWeight: '200',
        height:'100vh',
        width: '100%',        
        // backgroundColor: 'lightGray',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',

    }, 
   line: {       
     fontFamily:'Mulish', 
     display: 'flex', 
     flexDirection: 'row', 
     justifyContent: 'space-between',
     alignItems: 'center',  
     margin: '10px',
     backgroundColor: 'lightBlue',     
     padding: '10px',
    
     
   }
   ,



}));

function Home(props) {
  
  const classes = useStyles();

   
  return (  

    
    <div width='100%'>

      
        <div className={classes.maincolumn}>
                     
            {!props.isLoggedIn &&
              <Login checkLoginStatus={props.checkLoginStatus}/>
            }
            
            {props.isLoggedIn &&
              <InvoiceMainView checkLoginStatus={props.checkLoginStatus} />
            }
                      
        

        </div>

    </div>

  );
}




export default Home;
